import React from 'react';
import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';

import type { ThreadsQueryResult } from '@/api/generated';
import { Badge } from '@/components/ui/badge';

interface FeedbackBadgeProps {
  feedback: NonNullable<ThreadsQueryResult['data'][number]['feedback']>;
}

const FeedbackBadge = ({ feedback }: FeedbackBadgeProps) => (
  <Badge
    variant={
      // eslint-disable-next-line no-nested-ternary
      feedback.conclusion === 'positive'
        ? 'success'
        : feedback.conclusion === 'negative'
          ? 'destructive'
          : 'warning'
    }
    className='flex items-center gap-2'>
    <div className='flex items-center gap-1'>
      <ThumbsUpIcon className='size-3' /> <span>{feedback.positive}</span>
    </div>
    <div className='flex items-center gap-1'>
      <ThumbsDownIcon className='size-3' /> <span>{feedback.negative}</span>
    </div>
    {feedback.conclusion}
  </Badge>
);

export default FeedbackBadge;
